import React from 'react';
import { Toast, Upload } from '@roo/roo';
import PropType from 'prop-types';
import { get, isEqual } from 'lodash';
import { useUpdateEffect } from 'ahooks';
import axx from 'axios';
import { useDeepDeps } from '../_utils/hooks';
import { useSimpleContext } from '../_context';
import { FILETYPES, file_name_separator } from '../../../components/UploadPro';

import { FilesView } from '../../applyView/_components/FilesView';
import { genStr } from '../../../utils/utils';
import up_file from '../../../assets/images/apply/up_file.png';

const axios = axx.create({ withCredentials: false });

function getFileList(fileUrls = []) {
  if (typeof fileUrls === 'string') {
    fileUrls = [fileUrls];
  }

  const t = Date.now().valueOf();
  return fileUrls.filter(Boolean).map((url, idx) => {
    const xs = url.split('/');
    return {
      name: xs.pop(),
      uid: String(t + idx),
      url,
      status: 'success',
      key: url,
    };
  });
}

export const UploadField = function (props) {
  const { state } = useSimpleContext((t) => [t.token]);
  const [fileList, setFileList] = React.useState(getFileList(props.value));
  const { type, maxFiles = 1, limitSizeTip = '10M' } = props;
  const { token } = state;
  const { accept, size } = FILETYPES[type];
  const s3url = `https://mss.sankuai.com/${state.token.bucketName}`;
  const isList = Array.isArray(props.value);

  function getFileUrls(files) {
    const urls = files.map((f) => get(f, 'key')).filter(Boolean);
    return isList ? urls : urls[0];
  }

  useUpdateEffect(
    () => {
      if (!isEqual(props.value, getFileUrls(fileList))) {
        setFileList(getFileList(props.value));
      }
    },
    [useDeepDeps(props.value)],
  );

  function handleUpload(file) {
    const { policy, signature, awsaccessKeyId } = state.token;
    const params = {
      policy, key: file.key, signature, awsaccessKeyId,
    };
    const formData = new FormData();

    Object.entries(params).forEach(([k, v]) => {
      formData.append(k, v);
    });
    formData.append('file', file);
    axios.post(s3url, formData).then((res) => {
      if (res.status === 200) {
        const newFiles = [...fileList, file];
        setFileList(newFiles);
        if (props.handleChange) {
          props.handleChange(getFileUrls(newFiles));
        }
      } else {
        Toast.fail({ title: '上传失败' });
      }
    });
  }

  const children = props.children || (
    <div className="upload">
      {/*<Icon name='upload' />*/}
      <img src={up_file} alt="" />
      <p>请点击或拖拽文件至此上传</p>
      <p>
        请上传
        {accept.replace(/\,/g, '/')}
        格式的文件,大小不超过
        {limitSizeTip}
      </p>
    </div>
  );
  if (props.disabled || state.isViewType || state.disabled) {
    return <FilesView value={fileList.map((f) => f.key).filter(Boolean)} />;
  }

  return (
    <div className={fileList.length < maxFiles ? 'file-input' : 'file-full'}>
      <Upload
        canDrop
        showUploadList
        style={props.style}
        disabled={props.disabled}
        showType="list"
        withCredentials={false}
        fileList={fileList.map((f) => {
          let name = f.name;
          try {
            const ns = f.name.split(file_name_separator).filter(Boolean).pop();
            name = ns || name;
          } catch (e) {
            // nox
          }
          return { ...f, name };
        })}
        className="dropClass"
        validityCallback={(files) => {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.size > props.maxSize) {
              Toast.fail({
                title: '文件大小超过限制',
              });
              return false;
            }
            if (file.name.includes('@')) {
              Toast.fail({
                title: '标题包含特殊符号，上传失败',
              });
              return false;
            }
            // 拼接文件路径，使用分隔符将文件路径和名称进行分割
            const k = `${token.dir}${genStr()}${file_name_separator}${file.name}`.replace(/\s/g, '');
            file.key = k;
            handleUpload(file);
          }
          return false;
        }}
        accept={accept}
        size={size}
        action={s3url}
        onRemove={(file, FileList) => {
          if (props.handleChange) {
            props.handleChange(getFileUrls(FileList));
          }
        }}
      >
        {fileList.length < maxFiles ? children : null}
      </Upload>
    </div>
  );
};

UploadField.propTypes = {
  maxFiles: PropType.number,
  // 单位是b
  maxSize: PropType.number,
  disabled: PropType.bool,
  value: PropType.arrayOf(PropType.string),
  handleChange: PropType.func,
  accept: PropType.arrayOf(PropType.string),
  style: PropType.object,
  type: PropType.string,
};

UploadField.defaultProps = {
  files: [],
  maxSize: 10 * 1024 * 1024,
  maxFiles: 1,
  accept: [],
  type: 'img',
};
